import { Page } from '@dixa/lib-shared-habla';

import { PreferencesKeyboardShortcutsForm } from '../preferences/views/preferencesKeyboardShortcutsForm/preferencesKeyboardShortcutsForm.view';

export const SettingsKeyboardShortcutsView = (): JSX.Element => {
  return (
    <Page>
      <Page.Head title="Keyboard shortcuts" />

      <Page.Body>
        <PreferencesKeyboardShortcutsForm />
      </Page.Body>
    </Page>
  );
};
